
<div class="modal-dialog" style="max-width: 1000px;">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Fix Accessory</h4>
      <button class="close" type="button" (click)="close()">&times;</button>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <div class="row">
        <form>
          <div class="col form-group">
            <label class="required" for="serialNumber">Serial Number or Map ID:</label>
            <div class="input-group">
              <input class="form-control" id="serialNumber" type="text" name="serialNumber" [(ngModel)]="serialNumber">
              <div class="input-group-append">
                <button class="btn btn-outline-primary" type="button" (click)="loadData()">Search</button>
              </div>
            </div>
          </div>
          <div class="col form-group">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="attachToOrder" autoLinkToLabel name="attachToOrder">
              <label class="form-check-label">Attach to same hardware order (if one exists and hasn't been confirmed or placed)</label>
            </div>
          </div>
          <div class="col form-group">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="attachToDeployment" autoLinkToLabel name="attachToDeployment">
              <label class="form-check-label">Attach to same deployment (if one exists, even if already installed)</label>
            </div>
          </div>
        </form>
      </div>
      <div class="row">
        <div class="col">
          <table class="table table-responsive table-sm">
            <thead>
              <tr>
                <th>Product Number</th>
                <th>Serial Number</th>
                <th>Map ID</th>
                <th>Order</th>
                <th>Deployment</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="6" *ngIf="loading">
                  <md-spinner-block></md-spinner-block>
                </td>
              </tr>
              <ng-template ngFor let-row [ngForOf]="rows">
                <tr>
                  <td>{{ row.productNumber }}</td>
                  <td>{{ row.serialNumber }}</td>
                  <td>{{ row.floorMapId }}</td>
                  <td>{{ row.orderName }}</td>
                  <td>{{ row.deploymentName }}</td>
                  <td>
                    <button class="btn btn-outline-primary btn-sm" (click)="assign(row)">Convert & attach here</button>
                  </td>
                </tr>
                <tr class="no-top-border no-top-padding" *ngIf="row.tooLateToOrder">
                  <td class="text-red" colspan="6">This asset was already ordered and the accessory must be manually added to a new order form.</td>
                </tr>
                <tr class="no-top-border no-top-padding" *ngIf="!row.orderId">
                  <td class="text-red" colspan="6">This asset has no associated order form.</td>
                </tr>
                <tr class="no-top-border no-top-padding" *ngIf="row.installed">
                  <td class="text-red" colspan="6">This asset was already installed and you may need to update SAP or other systems manually.</td>
                </tr>
                <tr class="no-top-border no-top-padding" *ngIf="!row.deploymentId">
                  <td class="text-red" colspan="6">This asset ahs no associated deployment.</td>
                </tr>
              </ng-template>
              <tr>
                <td class="text-right" colspan="6">
                  <button class="btn btn-outline-secondary btn-sm" (click)="assign()">Convert to standalone accessory without linking to an asset</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" type="button" (click)="close()">Cancel</button>
    </div>
  </div>
</div>